import { Component, Input } from '@angular/core';
import { StrapiMedia } from '@portals/api';
import { saveAs } from 'file-saver';

@Component({
	selector: 'portals-image-viewer',
	templateUrl: './image-viewer.component.html',
	styleUrls: ['./image-viewer.component.scss'],
})
export class ImageViewerComponent {
	@Input() source: StrapiMedia[] = [];
}
